import { FlowConditionAppVBOWaardecheckReportDetails } from './types.flow';

import { emptyVBOWaardecheckReportEventParameterValue } from '~/scenes/Automation/Flows/Actions/Base/FlowParameter/ParameterValue/Event';
import { DEFAULT_ALL_SHOULD_BE_TRUE } from '~/scenes/Automation/Flows/Actions/Base/FlowConditionList/expressionHelpers';
import { FLOW_CONDITION_TYPES } from '../constants';

const emptyFlowConditionAppVBOWaardecheckReportDetails = (): Omit<
  FlowConditionAppVBOWaardecheckReportDetails,
  'id'
> => ({
  type: FLOW_CONDITION_TYPES.EVENT_CONTACT_APP_VBOWAARDECHECK_REPORT_DETAILS
    .type,
  fields: [],
  event: emptyVBOWaardecheckReportEventParameterValue(),
  allShouldBeTrue: DEFAULT_ALL_SHOULD_BE_TRUE,
});

export default emptyFlowConditionAppVBOWaardecheckReportDetails;
